function debounce(fn, wait = 0, options) {
  let timer;
  let pendingTrailing = false;
  let lastArgs;
  const debounced = (...args) => {
    lastArgs = args;
    if (options?.leading && timer === void 0) {
      pendingTrailing = false;
      fn(...args);
    } else {
      pendingTrailing = true;
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = void 0;
      if (pendingTrailing) {
        pendingTrailing = false;
        fn(...lastArgs);
      }
    }, wait);
  };
  debounced.cancel = () => {
    clearTimeout(timer);
    timer = void 0;
    pendingTrailing = false;
  };
  return debounced;
}
export {
  debounce
};
//# sourceMappingURL=debounce.js.map
